import { render } from "./Modulistica.vue?vue&type=template&id=528b06bc&scoped=true"
import script from "./Modulistica.vue?vue&type=script&lang=js"
export * from "./Modulistica.vue?vue&type=script&lang=js"

import "./Modulistica.vue?vue&type=style&index=0&id=528b06bc&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528b06bc"]])

export default __exports__